import React, { useEffect, useState } from 'react';
import { Form, Checkbox, Button, Skeleton, Empty, Typography, DatePicker, Steps, message } from 'antd';
import moment from 'moment';
import { CheckCircleOutlined } from '@ant-design/icons';
import AsyncSelect from 'react-select/async';
import OpregSearch from '../../../../candidate-visit/opreg-search';
import NewAppointmentIcon from '/src/assets/icons/NewAppointmentIcon.png';
import { Appointments } from '../../../../../models';
import { Location, useTranslation } from 'soxo-bootstrap-core';
import './existing-user.scss';
import ExistingAppointmentIcon from '/src/assets/icons/ExistingAppointmentIcon.png';

const { RangePicker } = DatePicker;
const { Title, Text } = Typography;

const ExistingUser = () => {
    const { t } = useTranslation();
    let urlParams = Location.search();

    const [form] = Form.useForm();
    const [allbranch, setAllbranch] = useState(false);
    const [appointments, setAppointmenets] = useState([]);
    const [choice, setChoice] = useState('New Customer');
    const [docapp, setDocapp] = useState({});
    const [opreg, setOpReg] = useState([]);
    const [range, setRange] = useState([moment().startOf('day'), moment().endOf('month')]);
    const [loading, setLoading] = useState(false);

    // Modes of booking
    const modes = ['New Customer'];

    if (urlParams.mode !== 'Walk In') {
        modes.push('Existing Customer');
    }

    function updateAllBranch(event) {
        setAllbranch(event.target.checked);
    }

    /**
     * Fetches appointment records within a given date range and updates component state.
     **/
    function getAppointments(pageNo, range) {
        setLoading(true);

        Appointments.getAppointments(1, range, 50).then((result) => {
            // Filter appointments
            let filtered = result.filter((record) => !record.da_newopno && record.preReg && record.da_packagetypevalue);

            setAppointmenets(filtered);

            setLoading(false);
        });
    }

    /**
     * Loads customer search results for the AsyncSelect component.
     **/
    function loadHeads(query) {
        setOpReg(null);

        // Base request body for the search API
        let formBody = {
            search_by: 'first_name',
            criteria: 'anywhere',
            search_text: query,
        };

        // If "search all branches" is enabled
        if (allbranch) {
            formBody = {
                ...formBody,
                index: 'ALL',
            };
        } else {
            // Otherwise, restrict search to a specific branch
            formBody = {
                ...formBody,
                index: localStorage.db_ptr ? localStorage.db_ptr : process.env.REACT_APP_DB_PTR,
            };
        }

        // Only make the API request if the user has typed 3+ characters
        if (query.length >= 3) {
            return Appointments.consolidatedSearch(formBody).then((response) => {
                // Map each result to a format usable by react-select (value + label)
                return response.result.map((item) => {
                    // Case: result has an OP number
                    if (item.op_number !== null)
                        return {
                            value: item.op_number,
                            label: item.first_name + ' ' + item.last_name + ' ' + '-' + ' ' + item.mobile1 + ' ' + '-' + ' ' + item.op_number,
                            ...item,
                        };
                    // Case: no OP number → use prereg_id instead
                    else
                        return {
                            value: item.prereg_id,
                            label: item.first_name + ' ' + item.last_name + ' ' + '-' + ' ' + item.mobile1 + ' ' + '-' + ' ' + item.prereg_id,
                            ...item,
                        };
                });
            });
        }
    }

    //Set opreg with selected customers details
    const handleChange = (result) => {
        if (result) {
            existingCustomerFunction(result);
        } else {
            setOpReg(null);
        }
    };
    const confirmAppointment = () => {
        if (choice === 'Online') {
            if (docapp && docapp.da_id) {
                var queryParam = {
                    da_id: docapp.da_id,
                    da_packagetypevalue: docapp.da_packagetypevalue,
                    da_doctorptr: docapp.da_doctorptr,
                    prereg_id: docapp.preReg.prereg_id,
                    mode: 'Online',
                };

                Location.navigate({ url: '/new-registration/guest', queryParam });
            }
        } else if (choice === 'Call') {
            var slotParam = {
                da_id: docapp.da_id,
                da_packagetypevalue: docapp.da_packagetypevalue,
                prereg_id: docapp.preReg.prereg_id,
            };

            Location.navigate({ url: '/new-registrations/slots', queryParam: slotParam });
        } else message.error('Please Select a Pateint');
    };

    function updateTime(dt) {
        setRange(dt);

        Location.search({
            start_time: moment(dt[0]).format('MM/DD/YYYY'),
            end_time: moment(dt[1]).format('MM/DD/YYYY'),
        });

        //Patiant list get function
        getAppointments(1, dt);
    }

    const existingCustomerFunction = async (opreg) => {
        const currentParams = new URLSearchParams(window.location.search);
        const currentPath = window.location.pathname;
        const newPath = currentPath.replace('/guest', '/existing-guest');
        currentParams.set('mode', 'Existing Customer');
        currentParams.set('repeat', 'true');

        if (opreg && opreg.db_ptr !== localStorage.db_ptr.toString()) {
            const opReg = await Appointments.createExistingCustomer(opreg);
            if (opReg?.opReg?.op_id) {
                currentParams.set('id', opReg.opReg.op_id);
                currentParams.set('table', 'opreg');
            } else if (opReg?.preReg?.prereg_id) {
                currentParams.set('id', opReg.preReg.prereg_id);
                currentParams.set('table', 'prereg');
            }
        } else if (opreg?.op_id) {
            currentParams.set('id', opreg.op_id);
            currentParams.set('table', 'opreg');
        } else if (opreg?.prereg_id) {
            currentParams.set('id', opreg?.prereg_id);
            currentParams.set('table', 'prereg');
        }

        const newUrl = `${newPath}?${currentParams.toString()}`;

        // Update URL
        Location.navigate({ url: newUrl });
    };

    // Update setChoice based on mode from URL
    useEffect(() => {
        if (urlParams.mode) {
            const decodedMode = decodeURIComponent(urlParams.mode.replace(/\+/g, ' '));
            setChoice(decodedMode);
        }
    }, [urlParams.mode]);

    return (
        <div className=" form-step">
            <div className="section-row">
                <h3 className="title">Choose Your Appointment Type</h3>{' '}
            </div>
            <div className="appointment-row">
                <div className="registration-mode">
                    {modes.map((mode, index) => (
                        <div
                            key={index}
                            className={`appointment-type ${
                                mode.toLowerCase().trim() === choice.toLowerCase().trim() ? 'appointment-type--active' : ''
                            }`}
                            onClick={() => setChoice(mode.trim())}
                        >
                            <CheckCircleOutlined />
                            {mode}
                            {mode === 'New Customer' ? (
                                <img src={NewAppointmentIcon} alt="New" style={{ marginLeft: '5px' }} />
                            ) : (
                                <img src={ExistingAppointmentIcon} alt="Existing" style={{ marginLeft: '5px' }} />
                            )}
                        </div>
                    ))}

                    {/** consolidatedSearch Api search  Ends */}
                    {choice === 'Existing Customer' ? (
                        <>
                            <div className="registration-mode">
                                <Form
                                    form={form}
                                    onValuesChange={(feilds) => {
                                        setOpReg(null);
                                    }}
                                >
                                    <div className="guest-search-wrapper">
                                        <AsyncSelect
                                            className="search"
                                            value={opreg}
                                            onChange={handleChange}
                                            // cacheOptions
                                            defaultOptions
                                            loadOptions={loadHeads}
                                            isClearable="true"
                                        />
                                        <OpregSearch
                                            enableVisit={false}
                                            callback={(opreg) => {
                                                existingCustomerFunction(opreg);
                                                // setChoice('Existing Customer');
                                            }}
                                            model={Appointments}
                                            title={t('Advance Search')}
                                            shouldMigrateAccount={false}
                                        />
                                        <div className="checkbox-input">
                                            <Checkbox value={allbranch} onChange={updateAllBranch} />
                                            <span className="caption">Search ALL Branches</span>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </>
                    ) : null}
                </div>

                {/* Selection Content */}

                <div className="form-content">
                    {/* Package selection for Offline Cases */}

                    {choice === 'Online' ? (
                        <>
                            <div className="block-header">
                                <div>
                                    {/* Appointment Listing */}
                                    <Title level={5}>{t('Continue with Registration')}</Title>

                                    <p style={{ marginTop: '35px' }}>
                                        {loading ? (
                                            t('Loading appointments')
                                        ) : (
                                            <>{appointments.length ? 'Select the appointment to continue' : 'No results'}</>
                                        )}
                                    </p>
                                </div>

                                <RangePicker
                                    allowClear={false}
                                    inputReadOnly
                                    format={'DD/MM/YYYY'}
                                    value={range}
                                    onChange={(time) => {
                                        updateTime(time, range);
                                    }}
                                    ranges={{
                                        Today: [moment(), moment()],

                                        Yesterday: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],

                                        'This Week': [moment().startOf('week'), moment().endOf('week')],

                                        'Last Week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],

                                        'This Month': [moment().startOf('month'), moment().endOf('month')],

                                        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                                    }}
                                />
                            </div>

                            {loading ? (
                                <Skeleton />
                            ) : (
                                <>
                                    {appointments.map((guest, key) => {
                                        return <AppointmentCard key={key} selected={docapp} onClick={() => setDocapp(guest)} guest={guest} />;
                                    })}
                                    {appointments.length ? (
                                        <>
                                            <Button type="primary" onClick={confirmAppointment}>
                                                {t('Proceed')}
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            <Empty description={false} />
                                        </>
                                    )}
                                </>
                            )}
                        </>
                    ) : null}
                </div>

                {/* Selection Content Ends */}
            </div>
        </div>
    );
};

/**
 * Component to show the appointment
 *
 * @param {*} param0
 * @returns
 */
function AppointmentCard({ guest, callback, onClick, selected }) {
    return (
        <div className={`appointment-card ${selected.da_id === guest.da_id ? 'active' : ''}`} onClick={onClick}>
            <Text level={5} className="top-content">
                <p className={'name'}>
                    {guest.da_fname} {guest.da_lname}
                </p>

                <p>{moment(guest.da_date).format('DD/MM/YYYY HH:MM')}</p>
            </Text>

            <CheckCircleOutlined />
        </div>
    );
}

export default ExistingUser;
